import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Role } from '../../models/rbac';
import { CrudService } from '../crud.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends CrudService<Role> {
  protected basePath = 'role';
  public instanceType = 'role';

  constructor(http: HttpClient) {
    super(http);
  }
}
